import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Icon,
  Input,
  InputGroup,
  InputRightAddon,
  Select,
  Switch,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { FaEye, FaPlus } from "react-icons/fa";
import { componentState } from "../../../../atoms/componentState";
import {
  BLUEMONEDDBUTTONS,
  GRAY,
  REDMONEDD,
  WHITE,
} from "../../../../constants/colors";
import TitleFlex from "../defaultComponents/titleFlex";
import { useSetRecoilState } from "recoil";
import { useEffect, useState } from "react";
import { parcelasvendaDigitada } from "../defaultComponents/parcelas";
import { useNavigate } from "react-router-dom";
import { goToVendaDigitadaList } from "../../../../routes/coordinator";
import ModalRevisãoVendaDigitada from "./ModalRevisãoVendaDigitada";
import { NumericFormat } from "react-number-format";
import jwt_decode from "jwt-decode";
import { JWTToken } from "../../../../routes/privateRoute";
import PermissionsAPI from "../../../../services/permissionsAPI";
import { LoggedUser } from "../../../../atoms/userLogged";
import { selectedClientHeader } from "../../../../atoms/selectedClientHeader";
import { useRecoilState } from "recoil";

export interface PostVendaDigitada {
  idCliente: number;
  nomePagador: string;
  emailPagador: string;
  permitirPix: boolean;
  parcelaMinima: number;
  parcelaMaxima: number;
  mensagem: string;
  itens: Array<ItensVendadigitada>;
  regras?: Array<RulesVendasDigitadas>;
}
export interface ItensVendadigitada {
  descricao: string;
  valorItem: number;
  quantidade: number;
  codigo: string;
}

export interface RulesVendasDigitadas {
  variavel: string;
  regra: string;
  valor: number;
  modo: string;
  taxa: number;
}

export default function AddVendaDigitada() {
  const navigate = useNavigate();
  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Nova Venda Digitada");
    getAllPerms();
  }, []);
  const [perms, setPerms] = useState(Array<{}>);
  const token = window.localStorage.getItem("token");

  let jwtToken: JWTToken = jwt_decode(token || "");
  // const idClient = Number(jwtToken.idCliente);
  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  const idClient = user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);
  
  async function getAllPerms () {
    try {
      const response = await PermissionsAPI.getPermissions(idClient);
      setPerms(response);
    } catch (error) {
      console.log(error)
    }
  }

  // const permited = perms && perms.findIndex((perm: any) => perm.idPermissoes == 23) !== -1 ?  
  // false : (perms.findIndex((perm: any) => perm.idPermissoes == 25) !== -1 ? true : false);

  const initialState = {
    idCliente: idClient,
    nomePagador: "",
    emailPagador: "",
    permitirPix: true,//permited,
    parcelaMinima: 1,
    parcelaMaxima: 1,
    mensagem: "",
    itens: [],
    regras: [],
  };
  const initialStateItem = {
    descricao: "",
    valorItem: 0,
    quantidade: 1,
    codigo: "",
  };
  const initialstateRules = {
    variavel: "NUM_PARCELAS",
    regra: "==",
    valor: 1,
    modo: "FIXO",
    taxa: 0,
  };

  const [object, setObject] = useState<PostVendaDigitada>(initialState);
  const [itensVenda, setItensVenda] = useState(Array<ItensVendadigitada>);
  const [novoItem, setNovoItem] =
    useState<ItensVendadigitada>(initialStateItem);
  const [objetoModal, setObjetoModal] =
    useState<PostVendaDigitada>(initialState);
  const [OpenModal, setOpenModal] = useState(false);
  const [listaRegras, setListaRegras] = useState(Array<RulesVendasDigitadas>);
  const [novaRegra, setNovaRegra] =
    useState<RulesVendasDigitadas>(initialstateRules);
  const [description, setDescription] = useState(100);
  const [message, setMessage] = useState(200);

  const maxLength = 100;
  const maxLengthTextArea = 200;

  function onsubmit() {
    const objeto = {
      idCliente: idClient,
      nomePagador: object.nomePagador,
      emailPagador: object.emailPagador,
      permitirPix: true, //object.permitirPix,
      parcelaMinima: object.parcelaMinima,
      parcelaMaxima: object.parcelaMaxima,
      mensagem: object.mensagem,
      itens: itensVenda,
      regras: listaRegras,
    };
    setObjetoModal(objeto);
    setOpenModal(true);
    // console.log("objeto", objeto);
  }

  function onChangeParcelaMinima(e: any) {
    setObject({ ...object, parcelaMinima: Number(e.target.value) });
  }
  function onChangeParcelaMaxima(e: any) {
    setObject({ ...object, parcelaMaxima: Number(e.target.value) });
  }

  function onChangeVariableRule(e: any) {
    setNovaRegra({ ...novaRegra, variavel: e.target.value });
  }

  function onChangeRule(e: any) {
    setNovaRegra({ ...novaRegra, regra: e.target.value });
  }

  function onChangeParcelasRules(e: any) {
    setNovaRegra({ ...novaRegra, valor: Number(e.target.value) });
  }
  function onChangeRuleMode(e: any) {
    setNovaRegra({ ...novaRegra, modo: e.target.value });
  }

  function onChangeValorFixo(e: any) {
    // console.log("valor fixo", e);
    setNovaRegra({
      ...novaRegra,
      taxa: Number(e.target.value.slice(3).replace(",", ".")),
    });
  }

  function onChangeValorPercentual(e: any) {
    setNovaRegra({ ...novaRegra, taxa: Number(e.target.value) });
  }

  function submitItensToList() {
    itensVenda.push(novoItem);
    setNovoItem(initialStateItem);
  }

  function submitRulesToList() {
    listaRegras.push(novaRegra);
    setNovaRegra(initialstateRules);
  }

  function removeItem(index: number) {
    const item = Array.from(itensVenda);
    item.splice(index, 1);
    setItensVenda(item);
  }

  function removeRule(index: number) {
    const item = Array.from(listaRegras);
    item.splice(index, 1);
    setListaRegras(item);
  }

  return (
    <Flex
      w={"100%"}
      h={"90vh"}
      bgColor={WHITE}
      px={10}
      pt={4}
      shadow={"lg"}
      overflowY={"scroll"}
      flexDir={"column"}
    >
      <Flex
        w={"100%"}
        h={"fit-content"}
        flexDir={"row"}
        justifyContent={"flex-end"}
        px={5}
      >
        <Button
          bgColor={GRAY}
          color={WHITE}
          onClick={() => {
            goToVendaDigitadaList(navigate);
          }}
        >
          Voltar
        </Button>
      </Flex>
      {/* <TitleFlex item={"Informe o cliente"} />
      <Box w={"25%"}>
        <ClientSelect cliente={cliente} setCliente={setCliente} />
      </Box> */}
      <TitleFlex item={"Informe os dados do pagador"} />
      <Flex w={"100%"} h={"fit-content"} flexDir={"row"} mb={2}>
        <FormControl px={2}>
          <FormLabel>E-mail</FormLabel>
          <Input
            placeholder="E-mail do Pagador"
            onChange={(e: any) => {
              setObject({ ...object, emailPagador: e.target.value });
            }}
          />
        </FormControl>
        <FormControl px={2}>
          <FormLabel>Nome</FormLabel>
          <Input
            placeholder="Nome do Pagador"
            onChange={(e: any) => {
              setObject({ ...object, nomePagador: e.target.value });
            }}
          />
        </FormControl>
      </Flex>
      {/* <TitleFlex item={"Informações sobre pagamento"} /> */}
      {/* {
        perms && 
        perms.findIndex((perm: any) => perm.idPermissoes == 23) !== -1 && 
        perms.findIndex((perm: any) => perm.idPermissoes == 25) !== -1 ? 
          <>
            <Flex>
              <Switch
                size="md"
                ml={3}
                mr={3}
                isChecked={object.permitirPix}
                onChange={(e: any) => {
                  setObject({ ...object, permitirPix: !object.permitirPix });
                }}
              ></Switch>
              <Text>Permitir pagamento por PIX</Text>
            </Flex>
          </>
          :
          (
            perms && 
            perms.findIndex((perm: any) => perm.idPermissoes == 23) !== -1 &&
            perms.findIndex((perm: any) => perm.idPermissoes == 25) === -1? 
              <>
              </>
              :
              (
                perms && 
                perms.findIndex((perm: any) => perm.idPermissoes == 23) === -1 &&
                perms.findIndex((perm: any) => perm.idPermissoes == 25) !== -1? 
                <>
                  <Flex>
                    <Switch
                      size="md"
                      ml={3}
                      mr={3}
                      isChecked={true}
                      onChange={(e: any) => {
                        // setObject({ ...object, permitirPix: !object.permitirPix });
                      }}
                    ></Switch>
                    <Text>Permitir pagamento por PIX</Text>
                  </Flex>
                </>
                :
                <>
                  
                </>
              )
          )
      } */}
      {/* <Flex>
        <Switch
          isChecked
          isDisabled
          size="md"
          ml={3}
          mr={3}
          // onChange={(e: any) => {
          //   setObject({ ...object, permitirPix: !object.permitirPix });
          // }}
        >Permitir pagamento por PIX</Switch>
      </Flex> */}
      {!object.permitirPix ? (
        <>
          <Flex w={"100%"} h={"fit-content"} flexDir={"row"} my={2}>
            <FormControl px={2}>
              <FormLabel>Parcelamento mínimo</FormLabel>
              <Select
                placeholder=""
                value={object.parcelaMinima.toString()}
                onChange={onChangeParcelaMinima}
              >
                {parcelasvendaDigitada.map((item) => {
                  return (
                    <option value={item.value} key={item.key}>
                      {item.text}
                    </option>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl px={2}>
              <FormLabel>Parcelamento máximo</FormLabel>
              <Select
                placeholder=""
                value={object.parcelaMaxima.toString()}
                onChange={onChangeParcelaMaxima}
              >
                {parcelasvendaDigitada.map((item) => {
                  return (
                    <option value={item.value} key={item.key}>
                      {item.text}
                    </option>
                  );
                })}
              </Select>
            </FormControl>
          </Flex>
          {/* <TitleFlex item={`Regras (Opcional)`} />
          <Flex w={"100%"} h={"fit-content"} flexDirection={"column"} px={4}>
            <Text fontSize={"13px"}>
              As regras podem ser utilizadas para aplicar juros. Elas podem ser
              do tipo "igual a", "maior ou igual que", "maior que".
            </Text>
            <Text fontSize={"13px"}>
              Podendo haver apenas uma regra para cada número de parcelas, no
              caso de regras do tipo "Maior ou igual" ou "Maior que" elas serão
              aplicadas até a próxima regra.
            </Text>
            <Text fontSize={"13px"}>
              {
                "Exemplo: Num. de parcelas >= 2 aplicar 3% de juros deixará de ser aplicada em uma regra subsequente ex: Num. de parcelas > 6 aplicar 6%, a taxa passará a ser de 6%."
              }
            </Text>
          </Flex> */}
          <Flex
            w={"100%"}
            h={"fit-content"}
            flexDir={"row"}
            my={2}
            alignItems={"end"}
          >
            <FormControl px={2} maxWidth={"16%"}>
              <FormLabel>Variável</FormLabel>
              <Select
                placeholder=""
                value={novaRegra.variavel}
                onChange={onChangeVariableRule}
              >
                <option value={"NUM_PARCELAS"}>Número de Parcelas</option>
              </Select>
            </FormControl>
            <FormControl px={2} maxWidth={"16%"}>
              <FormLabel>Regra</FormLabel>
              <Select
                placeholder=""
                value={novaRegra.regra}
                onChange={onChangeRule}
              >
                <option value={"=="}>Igual a</option>
                <option value={">"}>Maior que</option>
                <option value={">="}>Maior ou igual que</option>
              </Select>
            </FormControl>
            <FormControl px={2} maxWidth={"16%"}>
              <FormLabel>Parcelas</FormLabel>
              <Select
                placeholder=""
                value={novaRegra.valor.toString()}
                onChange={onChangeParcelasRules}
              >
                {parcelasvendaDigitada.map((item) => {
                  return (
                    <option value={item.value} key={item.key}>
                      {item.text}
                    </option>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl px={2} maxWidth={"16%"}>
              <FormLabel>Ajustar valor de modo</FormLabel>
              <Select
                placeholder=""
                value={novaRegra.modo}
                onChange={onChangeRuleMode}
              >
                <option value={"FIXO"}>Fixo</option>
                <option value={"PERCENTUAL"}>Percentual</option>
                <option value={"PERCENTUAL_COMPOSTO"}>
                  Percentual Composto
                </option>
              </Select>
            </FormControl>
            {novaRegra.modo === "FIXO" ? (
              <FormControl px={2} maxWidth={"16%"}>
                <FormLabel>Valor</FormLabel>
                <NumericFormat
                  decimalScale={2}
                  prefix="R$ "
                  value={novaRegra.taxa}
                  decimalSeparator=","
                  customInput={Input}
                  type="text"
                  placeholder="R$ 0,00"
                  onChange={onChangeValorFixo}
                />
              </FormControl>
            ) : (
              <FormControl px={2} maxWidth={"16%"}>
                <FormLabel>Percentual</FormLabel>
                <Input
                  placeholder="Digite o Percentual"
                  value={novaRegra.taxa}
                  onChange={onChangeValorPercentual}
                />
              </FormControl>
            )}
            <Button
              bgColor={BLUEMONEDDBUTTONS}
              isDisabled={novaRegra.taxa > 0 ? false : true}
              color={WHITE}
              width={"20%"}
              onClick={() => {
                submitRulesToList();
              }}
            >
              <Icon mr={2} as={FaPlus} />
              Adicionar
            </Button>
          </Flex>
          {listaRegras.length ? (
            <>
              <TitleFlex item={"Reagras cadastrados para esta venda"} />
              <Flex
                w={"100%"}
                h={"fit-content"}
                flexDir={"row"}
                mt={4}
                alignItems={"end"}
                justifyContent={"flex-start"}
              >
                <TableContainer>
                  <Table>
                    <Thead>
                      <Tr>
                        <Th
                          borderRadius={"8px 0 0 8px"}
                          bgColor={BLUEMONEDDBUTTONS}
                          color={WHITE}
                        >
                          Variável
                        </Th>
                        <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                          Regra
                        </Th>
                        <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                          Parcela
                        </Th>
                        <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                          Modo
                        </Th>
                        <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                          Taxa
                        </Th>
                        <Th
                          borderRadius={"0 8px 8px 0"}
                          bgColor={BLUEMONEDDBUTTONS}
                          color={WHITE}
                        >
                          Opções
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {listaRegras &&
                        listaRegras.map((item, index) => {
                          return (
                            <Tr key={index}>
                              <Td>
                                {item.variavel === "NUM_PARCELAS" &&
                                  "Número de Parcelas"}
                              </Td>
                              <Td>{item.regra}</Td>
                              <Td>{item.valor}</Td>
                              <Td>
                                {(item.modo === "FIXO" && "Fixo") ||
                                  (item.modo === "PERCENTUAL" &&
                                    "Percentual") ||
                                  (item.modo === "PERCENTUAL_COMPOSTO" &&
                                    "Percentual Composto")}
                              </Td>
                              <Td>
                                {item.modo === "FIXO"
                                  ? item.taxa.toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })
                                  : `${item.taxa} %`}
                              </Td>
                              <Td>
                                <Button
                                  bgColor={REDMONEDD}
                                  color={WHITE}
                                  onClick={() => {
                                    removeRule(index);
                                  }}
                                >
                                  <Text fontWeight={"bold"}>X</Text>
                                </Button>
                              </Td>
                            </Tr>
                          );
                        })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Flex>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
      <TitleFlex item={"Informe o produto ou serviço"} />
      <Flex
        w={"100%"}
        h={"fit-content"}
        flexDir={"row"}
        my={2}
        alignItems={"end"}
        justifyContent={"space-evenly"}
      >
        <FormControl px={2} maxWidth={"20%"}>
          <FormLabel>Descrição</FormLabel>
          <InputGroup>
            <Input
              placeholder="Descrição do Produto"
              value={novoItem.descricao}
              onChange={(e: any) => {
                setNovoItem({ ...novoItem, descricao: e.target.value });
                setDescription((maxLength - e.target.value.length))
              }}
              maxLength={maxLength}
            />
            <InputRightAddon w={"30%"} p={0} >
              <Box
                px="2"
                py="1"
                // bg="gray.200"
                borderRadius="md"
                fontSize="sm"
                fontWeight="medium"
                color="gray.500"
              >
                {description}/{maxLength}
              </Box>
            </InputRightAddon>
          </InputGroup>
          
        </FormControl>
        <FormControl px={2} maxWidth={"20%"}>
          <FormLabel>Valor Unitário</FormLabel>
          <NumericFormat
            decimalScale={2}
            prefix="R$ "
            value={novoItem.valorItem}
            decimalSeparator=","
            customInput={Input}
            type="text"
            placeholder="R$ 0,00"
            onChange={(e: any) => {
              setNovoItem({
                ...novoItem,
                valorItem: Number(e.target.value.slice(3).replace(",", ".")),
              });
            }}
          />
        </FormControl>
        <FormControl px={2} maxWidth={"20%"}>
          <FormLabel>{`Quantidade (Opcional)`}</FormLabel>
          <Input
            placeholder="Quantidade"
            value={novoItem.quantidade}
            onChange={(e: any) => {
              setNovoItem({ ...novoItem, quantidade: Number(e.target.value) });
            }}
          />
        </FormControl>
        <FormControl px={2} maxWidth={"20%"}>
          <FormLabel>{`Código (Opcional)`}</FormLabel>
          <Input
            placeholder="Código"
            value={novoItem.codigo}
            onChange={(e: any) => {
              setNovoItem({ ...novoItem, codigo: e.target.value });
            }}
          />
        </FormControl>
        <Button
          bgColor={BLUEMONEDDBUTTONS}
          isDisabled={
            novoItem.descricao != "" && novoItem.valorItem > 0 ? false : true
          }
          color={WHITE}
          width={"20%"}
          onClick={() => {
            submitItensToList();
          }}
        >
          <Icon mr={2} as={FaPlus} />
          Adicionar
        </Button>
      </Flex>
      {itensVenda.length ? (
        <>
          <TitleFlex item={"Itens cadastrados para esta venda"} />
          <Flex
            w={"100%"}
            h={"fit-content"}
            flexDir={"row"}
            mt={4}
            alignItems={"end"}
            justifyContent={"flex-start"}
          >
            <TableContainer>
              <Table>
                <Thead>
                  <Tr>
                    <Th
                      borderRadius={"8px 0 0 8px"}
                      bgColor={BLUEMONEDDBUTTONS}
                      color={WHITE}
                    >
                      Descrição
                    </Th>
                    <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                      Valor
                    </Th>
                    <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                      Quantidade
                    </Th>
                    <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                      Código
                    </Th>
                    <Th
                      borderRadius={"0 8px 8px 0"}
                      bgColor={BLUEMONEDDBUTTONS}
                      color={WHITE}
                    >
                      Opções
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {itensVenda &&
                    itensVenda.map((item, index) => {
                      return (
                        <Tr key={index}>
                          <Td>{item.descricao}</Td>
                          <Td>
                            {item.valorItem.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          </Td>
                          <Td>{item.quantidade}</Td>
                          <Td>{item.codigo}</Td>
                          <Td>
                            <Button
                              bgColor={REDMONEDD}
                              color={WHITE}
                              onClick={() => {
                                removeItem(index);
                              }}
                            >
                              <Text fontWeight={"bold"}>X</Text>
                            </Button>
                          </Td>
                        </Tr>
                      );
                    })}
                </Tbody>
              </Table>
            </TableContainer>
          </Flex>
        </>
      ) : (
        <></>
      )}
      <TitleFlex item={"Mensagem para o pagador (opcional)"} />
      <Flex
        w={"100%"}
        h={"fit-content"}
        flexDir={"row"}
        my={2}
        alignItems={"end"}
        justifyContent={"space-evenly"}
      >
        <FormControl>
          <InputGroup>
            <Textarea
              placeholder="Mensagem..."
              onChange={(e: any) => {
                setObject({ ...object, mensagem: e.target.value });
                setMessage((maxLengthTextArea - e.target.value.length));
              }}
              maxLength={maxLengthTextArea}
            />
            <Flex
              textAlign="right"
              pt={1}
              alignItems={"center"}
              px="2"
              py="1"
              bg="gray.200"
              borderRadius="md"
              fontSize="sm"
              fontWeight="medium"
              color="gray.500"
            >
              <Text fontSize="sm" color="gray.500">
                {message}/{maxLengthTextArea}
              </Text>
            </Flex>
          </InputGroup>
        </FormControl>
      </Flex>
      <Flex
        w={"100%"}
        h={"fit-content"}
        flexDir={"row"}
        my={2}
        alignItems={"end"}
        justifyContent={"space-evenly"}
      >
        <Button
          bgColor={BLUEMONEDDBUTTONS}
          color={WHITE}
          width={"50%"}
          isDisabled={idClient <= 0}
          onClick={() => {
            onsubmit();
          }}
        >
          <Icon mr={2} as={FaEye} />
          Revisar Venda Digitada
        </Button>
      </Flex>
      <ModalRevisãoVendaDigitada
        isOpen={OpenModal}
        setIsOpen={setOpenModal}
        item={objetoModal}
      />
    </Flex>
  );
}
